var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkEnergyPurchased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #02222b;\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #fff;\n        opacity: .5;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #0eaa82;\n        stroke-linecap: round;\n        stroke-width: 5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,35.5s-3.9,25.8,15.7,34.4c23.9,10.5,38.9-10.1,38.9-10.1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.5,
    cy: 38.4,
    r: 30.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.2,31.7s-.2-7.5-9-7.5-10.2,5.9-10.2,5.9c0,0-1,2.7,1.5,5.2s9.4,4.2,11.3,4.7c1.9.5,3.9,1,5.3,3.4s.5,5.2-1.2,7-3.8,2.4-5.7,2.5-6.6.3-9.2-2.1c-2.3-2.1-2.3-4.9-2.3-4.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.2,
    y1: 24.1,
    x2: 39.2,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.5,
    y1: 59.8,
    x2: 38.5,
    y2: 52.9
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEnergyPurchased);
export default __webpack_public_path__ + "static/media/dark-energyPurchased.15b3c02b76c1f0feb8d474ef5d558bfb.svg";
export { ForwardRef as ReactComponent };